import { gql, useMutation } from "@apollo/client";
import * as CreateTemplateTypes from "./__generated__/CreateTemplate";
import { GetAvailableTemplates } from "../queries/__generated__/GetAvailableTemplates";
import { GET_AVAILABLE_TEMPLATES } from "../queries/getAvailableTemplates";

export const CREATE_TEMPLATE = gql`
    mutation CreateTemplate($input: ProcessTemplateInput!) {
        createProcessTemplate(input: $input) {
            companySysId
            processId
            indexType
            name
            description
            instructions {
                instructionId
                projectId
                indexType
                companySysId
                projectKey
                alias
                display
                userInputs
                precondition
                dependsOn
                outputs
            }
            outputs
        }
    }
`;

export function useCreateTemplate() {
    const [mutate, { data, error }] = useMutation<CreateTemplateTypes.CreateTemplate, CreateTemplateTypes.CreateTemplateVariables>(CREATE_TEMPLATE, {
        refetchQueries: [
            {
                query: GET_AVAILABLE_TEMPLATES
            }
        ],
        update: cache => {
            let allTemplates = cache.readQuery<GetAvailableTemplates>({
                query: GET_AVAILABLE_TEMPLATES
            });

            if (allTemplates) {
                cache.writeQuery({
                    query: GET_AVAILABLE_TEMPLATES,
                    data: {
                        availableProcessTemplates: allTemplates.availableProcessTemplates,
                        companies: allTemplates.companies
                    }
                });
            }
        }
    });

    return { mutate, data, error };
}
